import { UserType } from './user-type';
import { UserInterface } from './user.interface';

export class Admin implements UserInterface {
    id: number;
    name: string;
    username: string;
    password: any;
    createdAt: string;
    email: string;
    mobilePhone: any;
    phone: any;
    status: number;
    updatedAt: string;
    userType: UserType = UserType.ADMIN;
    isWeb: boolean;
    type: any;


    constructor(data: {}) {
        Object.assign(this, data);
        this.isWeb = +this.type !== 0;
    }

}
